module.exports = __webpack_public_path__ + "static/img/3.b4b64349.jpg";